import React from "react";

const LABELS = ["Job details", "Account", "Membership"];

export default function Steps({ active = 1 }) {
  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4">
      {LABELS.map((label, i) => {
        const n = i + 1;
        const on = n <= active;
        return (
          <React.Fragment key={label}>
            <div className="flex items-center gap-2">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[14px] font-medium ${on ? "bg-[#7c2233] text-white" : "bg-[#efe6e2] text-[#8a8285]"}`}>{n}</div>
              <span className={`text-[14px] ${n === active ? "text-[#1f1a1b] font-medium" : "text-[#8a8285]"}`}>{label}</span>
            </div>
            {n < LABELS.length && <div className="w-6 sm:w-12 h-px bg-[#e2d6d0]" />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
